"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSISTANT_PAUSE_TYPES = exports.ASSISTANT_PAUSE_TYPE_CATALOG = void 0;
exports.isAssistantPauseType = isAssistantPauseType;
exports.findAssistantPauseTypeCatalogEntry = findAssistantPauseTypeCatalogEntry;
exports.pauseTypeRequiresReason = pauseTypeRequiresReason;
/**
 * The fixed catalog of assistant pause types, in display order.
 */
exports.ASSISTANT_PAUSE_TYPE_CATALOG = [
    {
        value: 'VISITE_MEDICALE',
        label: 'Visite Médicale',
        requiresReason: false,
    },
    { value: 'AUTRE', label: 'Autre', requiresReason: true },
];
/**
 * The catalog pause-type values, in display order.
 */
exports.ASSISTANT_PAUSE_TYPES = exports.ASSISTANT_PAUSE_TYPE_CATALOG.map((entry) => entry.value);
/**
 * Returns true when `value` is a member of the fixed pause-type catalog.
 *
 * @param value - the candidate pause-type value
 * @returns whether the value is a known catalog pause type
 */
function isAssistantPauseType(value) {
    return exports.ASSISTANT_PAUSE_TYPES.includes(value);
}
/**
 * Finds the catalog entry for a pause-type value.
 *
 * @param value - the catalog value to look up
 * @returns the matching entry, or null when the value is not in the catalog
 */
function findAssistantPauseTypeCatalogEntry(value) {
    return (exports.ASSISTANT_PAUSE_TYPE_CATALOG.find((entry) => entry.value === value) ?? null);
}
/**
 * Whether a pause type requires a non-empty free-text reason.
 *
 * @param value - the pause-type value
 * @returns true when a reason is required (false for unknown values)
 */
function pauseTypeRequiresReason(value) {
    return findAssistantPauseTypeCatalogEntry(value)?.requiresReason ?? false;
}
